import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CrmBulkClientsComponent } from './crm-bulk-clients/crm-bulk-clients.component';
import { CrmListFeesComponent } from './crm-list-fees/crm-list-fees.component';
import { CrmCreateFeeComponent } from './crm-create-fee/crm-create-fee.component';
import { ClientFormComponent } from './crm-client-form/client-form.component';
import { CrmClientsListComponent } from './crm-list-clients/crm-clients-list.component';
import { ContactListComponent } from './crm-contacts-list/contacts-list.component';
import { BulkCreateFeesComponent } from './crm-bulk-create-fees/bulk-create-fees.component';

const routes: Routes = [
  {
    path: 'bulk-clients-list',
    component: CrmBulkClientsComponent,
  },
  {
    path: 'list-fees',
    component: CrmListFeesComponent,
  },
  {
    path: 'contacts-list',
    component: ContactListComponent,
  },
  {
    path: 'bulk-create',
    component: BulkCreateFeesComponent,
  },
  {
    path: 'clients-list',
    component: CrmClientsListComponent,
  },
  {
    path: 'create-fee',
    component: CrmCreateFeeComponent,
  },
  {
    path: 'client-form',
    component: ClientFormComponent,
  },
]


@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CrmRoutingModule { }
